import { FetchResult } from '@apollo/client'
import gql from 'graphql-tag'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'
import { CreateCustomerInput, MagentoCustomerOutput } from 'lib/types'
import { ServiceDependencies } from 'lib/core/services/magento'
import { apolloClient } from 'lib/core/services/magento/client'

export interface CreateCustomerMutationObject {
  mutation: {
    createCustomer: {
      __args: {
        input: {
          email: string
          firstname: string
          lastname: string
          password: string
          [key: string]: any
        }
      }
      customer: {
        email: boolean
        firstname: boolean
        lastname: boolean
      }
    }
  }
}

export const createCustomerMutationObject: CreateCustomerMutationObject = {
  mutation: {
    createCustomer: {
      __args: {
        input: {
          email: '',
          firstname: '',
          lastname: '',
          password: ''
        }
      },
      customer: {
        email: true,
        firstname: true,
        lastname: true
      }
    }
  }
}

export type CreateCustomerMutation =
  (input: CreateCustomerInput) => Promise<FetchResult<{ createCustomer: MagentoCustomerOutput }>>

export const createCreateCustomerMutation = ({
  getMutations,
  getQueries
}: ServiceDependencies): CreateCustomerMutation => async ({
  email,
  firstName,
  lastName,
  password,
  ...restInputParams
}) => {
  const mutation = getMutations().createCustomerMutation
  for (const key in restInputParams) {
    mutation.mutation.createCustomer.__args.input[key] = restInputParams[key]
  }
  mutation.mutation.createCustomer.__args.input.email = email
  mutation.mutation.createCustomer.__args.input.firstname = firstName
  mutation.mutation.createCustomer.__args.input.lastname = lastName
  mutation.mutation.createCustomer.__args.input.password = password

  return apolloClient.mutate({
    mutation: gql`${jsonToGraphQLQuery(mutation)}`
  })
}
